import { auth, firestore } from "../firebaseConfig";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs,doc,getDoc } from "firebase/firestore";
import { FiMenu, FiX } from "react-icons/fi"; // Import icons for menu toggle

const Navbar = ({ darkMode, setDarkMode }) => {
  const [user] = useAuthState(auth);
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [subscribed, setSubscribed] = useState(false)

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        // const userQuery = query(collection(firestore, "users"), where("uid", "==", user.uid));
        const userQuery = doc(firestore, "users", user.uid)
        const userSnapshot = await getDoc(userQuery);
        if (userSnapshot.exists()) {
          setRole(userSnapshot.data().role);
          setSubscribed(!!userSnapshot.data().subscriptionActive);
        }
      }
    };
    fetchUserRole();
  }, [user]);

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-md py-4 px-6 flex justify-between items-center">
      {/* Logo - Clicking redirects to home */}
      <h1
        className="text-2xl font-bold text-blue-600 dark:text-blue-400 cursor-pointer"
        onClick={() => navigate("/")}
      >
        Contract Manager
      </h1>

      {/* Mobile Menu Button */}
      <button className="md:hidden text-2xl text-gray-700 dark:text-gray-300" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* Desktop Menu */}
      <div className="hidden md:flex space-x-6 items-center">
        {user ? subscribed ? (
          <>
            <NavLink to="/" className="text-lg font-medium text-gray-700 dark:text-gray-300">Contracts</NavLink>
            <NavLink to="/upload" className="text-lg font-medium text-gray-700 dark:text-gray-300">Upload</NavLink>

            {/* Show "Manage Members" link only for admins */}
              <NavLink to="/manage-members" className="text-lg font-medium text-blue-600 dark:text-blue-300">
                Manage
              </NavLink>

            <span className="text-gray-700 dark:text-gray-300">{user.email}</span>
            <button className="px-4 py-2 rounded bg-red-500 text-white" onClick={() => signOut(auth)}>Logout</button>
          </>
        ):(          <>
          <NavLink to="/" className="text-lg font-medium text-gray-700 dark:text-gray-300">Contracts</NavLink>
          <NavLink to="/upload" className="text-lg font-medium text-gray-700 dark:text-gray-300">Upload</NavLink>
          {/* Show "Manage Members" link only for admins */}
            <NavLink to="/manage-members" className="text-lg font-medium text-blue-600 dark:text-blue-300">
              Manage
            </NavLink>

          <span className="text-gray-700 dark:text-gray-300">{user.email}</span>
          <button className="px-4 py-2 rounded bg-red-500 text-white" onClick={() => signOut(auth)}>Logout</button>
        </>
        ): (
          <>
            <NavLink to="/login" className="text-lg font-medium text-blue-600 dark:text-blue-300">Login</NavLink>
            <NavLink to="/signup" className="text-lg font-medium text-blue-600 dark:text-blue-300">Sign Up</NavLink>
          </>
        )}
        
        <button 
          className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? "Light Mode" : "Dark Mode"}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white dark:bg-gray-800 shadow-md flex flex-col items-center py-4 md:hidden">
          {user ? (
            <>
              <NavLink to="/" className="py-2 text-lg font-medium text-gray-700 dark:text-gray-300" onClick={() => setMenuOpen(false)}>Contracts</NavLink>
              <NavLink to="/upload" className="py-2 text-lg font-medium text-gray-700 dark:text-gray-300" onClick={() => setMenuOpen(false)}>Upload</NavLink>

              {/* Show "Manage Members" only for admins */}
                <NavLink to="/manage-members" className="py-2 text-lg font-medium text-blue-600 dark:text-blue-300" onClick={() => setMenuOpen(false)}>
                  Manage 
                </NavLink>

              <span className="py-2 text-gray-700 dark:text-gray-300">{user.email}</span>
              <button className="mt-2 px-4 py-2 rounded bg-red-500 text-white" onClick={() => { signOut(auth); setMenuOpen(false); }}>
                Logout
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" className="py-2 text-lg font-medium text-blue-600 dark:text-blue-300" onClick={() => setMenuOpen(false)}>Login</NavLink>
              <NavLink to="/signup" className="py-2 text-lg font-medium text-blue-600 dark:text-blue-300" onClick={() => setMenuOpen(false)}>Sign Up</NavLink>
            </>
          )}
          
          <button 
            className="mt-2 px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
            onClick={() => { setDarkMode(!darkMode); setMenuOpen(false); }}
          >
            {darkMode ? "Light Mode" : "Dark Mode"}
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
